import React from "react"
import { Box, Button } from "@mui/material"
import { useSignal } from "@preact/signals-react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { autoEuropeListData } from "Pages/AutoEuropeTool/Page/@signals"

const toOption = ({ id, name }) => ({ value: id, label: name })

export default function BulkSeasonSetToolbar({ selectedData, setSelectedRows }) {
	const seasonSet = useSignal(null)
	const isLoading = useSignal(false)
	const { showToast } = useToast()

	// TableSeeker already maps selectedData to the actual row objects array
	const count = selectedData?.length ?? 0

	const handleApply = async () => {
		if (!seasonSet.value) return
		const selected = (selectedData || []).filter(Boolean)
		const newSetId = seasonSet.value

		isLoading.value = true
		try {
			const updated = await postSubmit(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/edit-season-set`, {
				ids: selected.map(t => t.id),
				seasonSetId: newSetId,
			})
			const updatedById = Object.fromEntries((updated || []).map(t => [t.id, t]))
			autoEuropeListData.value = autoEuropeListData.value.map(t =>
				updatedById[t.id] ? updatedById[t.id] : t
			)
			showToast.success(`Season set updated for ${selected.length} tool${selected.length > 1 ? 's' : ''}`)
			setSelectedRows([])
			seasonSet.value = null
		} catch (e) {
			const body = await e?.json?.().catch(() => null)
			showToast.error(body?.error_msg || "Error updating season set")
		}
		isLoading.value = false
	}

	return (
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mr: 2 }}>
			<Box sx={{ minWidth: 260 }}>
				<AutocompleteAjaxSeeker
					label="Season Set"
					placeholder="Select a season set"
					urlAjax={`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/season-sets/list`}
					onAjax={options => options.map(toOption)}
					value={seasonSet.value}
					onChange={e => { seasonSet.value = e.target.value }}
				/>
			</Box>
			<Button
				variant="contained"
				size="small"
				disabled={!seasonSet.value || isLoading.value}
				onClick={handleApply}
				sx={{ whiteSpace: 'nowrap', height: 40 }}
			>
				{isLoading.value ? 'Applying…' : `Apply to ${count} tool${count !== 1 ? 's' : ''}`}
			</Button>
		</Box>
	)
}
